import { showErrorToast } from "src/components/AlertToastify/AlertToastify";

export interface ContactUsFeedbackPayload {
  firstName: string;
  lastName: string;
  email: string;
  message: string;
  section?: string;
  image?: File | null;
}

export const sendContactUsFeedback = async (
  accessAuthToken: string,
  payload: ContactUsFeedbackPayload
): Promise<{ success: boolean }> => {
  const url = `${process.env.REACT_APP_BACKEND_URL}/feedback/contact-us`;
  const formData = new FormData();
  formData.append("firstName", payload.firstName);
  formData.append("lastName", payload.lastName);
  formData.append("email", payload.email);
  formData.append("message", payload.message);
  formData.append("section", payload.section || "contact_us");
  if (payload.image) {
    formData.append("image", payload.image);
  }

  const response = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${accessAuthToken}`,
    },
    body: formData,
    credentials: "include",
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    const message = errorData.message || "Failed to send message. Please try again.";
    showErrorToast(message);
    throw new Error(message);
  }

  return response.json();
};
